<template>
  <div id="app">
    <Layout />
  </div>
</template>

<script>
import Layout from './layout/layout.vue';
import { socketIO } from "@/utils/socketIO";

export default {
  name: 'App',
  components: {
    Layout
  },
  created() {
    socketIO.connect();
  }
}
</script>

<style>
@import './assets/css/base.css';

#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>